//React App HTML Element
//Please keep this file as simple as possible by wrapping program logic in React Components

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router";
import "./global.css";
import { Auth0Provider } from "@auth0/auth0-react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Auth0Provider
        domain="auth-new.stationportal.nmp.nonprod-sinclairstoryline.com"
        clientId="vPFVEBYMMsx8Fub6K8NorFlssjMYzrJH"
        authorizationParams={{
            redirect_uri: window.location.origin,
            audience: "https://megasheet-test.sbgtv.com/api",
        }}
    >
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Auth0Provider>
);
